/**
 * Rosie -- NEMT Dispatch Platform
 * Copyright (c) 2025-2026 Commonwealth Transport LLC. All rights reserved.
 * PROPRIETARY AND CONFIDENTIAL. Unauthorized use, copying, or distribution is prohibited.
 */

import api from './api';

/**
 * Open a stored file (fax PDF, photo, document) in a new tab WITH auth.
 *
 * Plain <a href="/api/files/:id/download"> links carry no Authorization
 * header, so under the default-deny API gate (2026-07-03) they 401 and the
 * tab shows an error instead of the file. This fetches the file with the
 * logged-in token and shows it via a blob URL instead.
 *
 * Usage: <a href="#" onClick={(e) => openFile(fileId, e)}>...</a>
 * The window is opened synchronously from the click so popup blockers
 * (especially mobile Safari) allow it.
 */
export default async function openFile(fileId, e) {
  if (e) e.preventDefault();
  const win = window.open('', '_blank');
  if (win) {
    win.document.write('<p style="font-family:-apple-system,sans-serif;padding:24px;color:#666">Loading file...</p>');
  }
  try {
    const res = await api.get(`/files/${fileId}/download`, { responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    if (win) {
      win.location = url;
    } else {
      window.location = url;
    }
  } catch (err) {
    const msg = '<p style="font-family:-apple-system,sans-serif;padding:24px;color:#C62828">Could not load this file. Pull to refresh or log in again if this keeps happening.</p>';
    if (win) {
      win.document.open();
      win.document.write(msg);
      win.document.close();
    } else {
      alert('Could not load this file.');
    }
  }
}
